var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6915 13.7663C11.6915 12.3763 12.1037 11.0175 12.876 9.86174C13.6482 8.70599 14.7458 7.80519 16.03 7.27326C17.3142 6.74133 18.7273 6.60215 20.0906 6.87333C21.4539 7.1445 22.7062 7.81386 23.6891 8.79674C24.672 9.77962 25.3413 11.0319 25.6125 12.3952C25.8837 13.7585 25.7445 15.1716 25.2126 16.4558C24.6806 17.74 23.7798 18.8376 22.6241 19.6099C21.4683 20.3821 20.1095 20.7943 18.7195 20.7943C16.8556 20.7943 15.068 20.0538 13.75 18.7358C12.432 17.4178 11.6915 15.6302 11.6915 13.7663ZM30.4329 37.193H7.00619C6.07422 37.193 5.18042 36.8227 4.52141 36.1637C3.86241 35.5047 3.49219 34.6109 3.49219 33.679C3.49219 30.883 4.60286 28.2016 6.57987 26.2246C8.55688 24.2476 11.2383 23.137 14.0342 23.137H23.4049C26.2008 23.137 28.8822 24.2476 30.8592 26.2246C32.8362 28.2016 33.9469 30.883 33.9469 33.679C33.9469 34.6109 33.5766 35.5047 32.9176 36.1637C32.2586 36.8227 31.3648 37.193 30.4329 37.193Z",
    fill: "#BDC3C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8828 0.310547V44.1655",
    stroke: "#D6DCDF",
    strokeWidth: 1.82729
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.1d239ad3f143a819da19b0692a5cbf83.svg";
export { ForwardRef as ReactComponent };